import { doGet, doPost } from '@/tools/axios'

export default {
  getWelfareAwardInfo (year) {
    return doGet(`/welfare/awards/info?year=${year}`)
  },
  getMyProfile (year) {
    return doGet(`/welfare/user/my_profile?year=${year}`)
  },
  signIn (year) {
    return doPost(`/welfare/user/sign_in`, { year })
  },
  share (year) {
    return doPost(`/welfare/user/share`, { year })
  },
  getDailyQuestion (year) {
    return doGet(`/welfare/questions/daily?year=${year}`)
  },
  getNextQuestion (year) {
    return doGet(`/welfare/questions/next?year=${year}`)
  },
  answerQuestion (questionId, answer) {
    return doPost(`/welfare/questions/${questionId}/answer`, { answer })
  },
  getFlowerRecords (year, page, perPage) {
    return doGet(`/welfare/flower_records?year=${year}&page=${page}&perPage=${perPage}`)
  },
  getWelfareParticipants (year, sort, page, randomSeed = 0, perPage = 15) {
    return doGet(`/welfare/participants?year=${year}&sort=${sort}&random_seed=${randomSeed}&page=${page}&perPage=${perPage}`)
  },
  getParticipantInfo (participantId) {
    return doGet(`/welfare/participants/${participantId}`)
  },
  sendFlower (participantId, count) {
    return doPost(`/welfare/participants/${participantId}/send_flower`, { count })
  },
  getTopParticipants (year) {
    return doGet(`/welfare/participants?year=${year}&sort=vote_down&page=${1}&perPage=${4}`)
  },
  switchReminder (year, reminder) {
    return doPost(`/welfare/user/reminder`, { year, reminder })
  },
  getMyFlowerParticipants (year) {
    return doGet(`/welfare/flower_records/participants?year=${year}`)
  },
  getWelfareEnterpriseInfo (code) {
    return doGet(`/welfare/enterprises/getInfoByCode?code=${code}`)
  },
  bindWelfareEnterprise (code) {
    return doPost(`/welfare/enterprises/bind`, { code })
  }
}
